import { testApiService } from "@/src/lib/api-services/testApiServices";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import useAuth from "@/src/lib/hooks/useAuth";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import { useDispatch } from "react-redux";
import { updateCartCount } from "@/src/lib/store/cart/slice";
import { useEffect } from "react";

const useCheckoutHook = () => {
    const { isLoggedIn } = useAuth();
    const {
        data: checkoutData,
        refetch: refetchCheckoutData,
        isLoading: isCheckoutLoading,
        isFetching: isCheckoutFetching,
    } = useCustomQuery("cart", testApiService.getCart, {
        enabled: !!isLoggedIn,
        //staleTime: 5000, // Increased stale time to reduce refetching
    });

    const showLoader = isCheckoutLoading || isCheckoutFetching;
    
    const {
        data: cartCountData,
        refetch: isCartCountRefetch,
        isLoading: isCartCountLoading,
    } = useCustomQuery("cart_count", cartApiService.getCartCount, {
        enabled: !!isLoggedIn,
    });

    const dispatch = useDispatch();

    useEffect(() => {
        if (isLoggedIn && cartCountData?.data?.cartCount !== undefined) {
            dispatch(updateCartCount(cartCountData.data.cartCount));
            console.log("cartCountData", cartCountData.data.cartCount);
        }
    }, [isLoggedIn, cartCountData, dispatch]); // Added dependencies to ensure it runs only when necessary

    return {
        checkoutData,
        refetchCheckoutData,
        showLoader,
        cartCountData,
        isCartCountRefetch,
        isCartCountLoading,
    };
};

export default useCheckoutHook;
